import axios from 'axios';
import {
  getUserFromLS,
  setUserToLS
} from '../../../helpers/localstorage-helper';
import { ErrorToast } from '../../../components';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { KYC_BIRTH_DETAILS } from '../../../routes/routes';
import { changeUserInfo } from '../../../slices/auth-slice';
import { UserInfoType } from '../../../types/loginTypes';

interface ApprovalKycTermsType {
  approvalDate: string;
  history: any;
}

export const approveKycTerms = createAsyncThunk(
  'kyc/approveKycTerms',
  async (
    { approvalDate, history }: ApprovalKycTermsType,
    { rejectWithValue, dispatch }
  ) => {
    try {
      const { data } = await axios.post(`/user/kyc/terms-and-conditions`, {
        approvalDate
      });

      const kycStatus = data.data.kycStatus;

      const currentUser: UserInfoType = getUserFromLS();

      const user = { ...currentUser, kycStatus };

      dispatch(changeUserInfo(user));

      setUserToLS(user);

      history.push(KYC_BIRTH_DETAILS);

      return user;
    } catch (error: any) {
      ErrorToast(error.response.data.error);
      return rejectWithValue(error.response.data.error);
    }
  }
);
